<template>
  <Hero :title="data?.header.title" :subtitle="data?.header.subtitle" :narrow="true" :images="data?.header.images"/>
  <main class="main maxw--body">
    <div class="block grid--two-thirds gap--double">
      <div>
        <h2>{{ data?.contact_header }}</h2>
        <div v-html="$md.render(data?.contact_text || '')" class="rendered"></div>
        <h2 class="mt-2">{{ data?.location_header }}</h2>
        <div v-html="$md.render(data?.location_text || '')" class="rendered"></div>
      </div>
      <div>
        <div class="card mb-2">
          <h5 class="heading--small">{{ data?.opening_hours_heading }}</h5>
          <div v-html="$md.render(data?.opening_hours_description || '')" class="rendered"></div>
        </div>
        <div class="card">
          <Mapbox/>
        </div>
      </div>
    </div>
  </main>
</template>

<script lang="ts" setup>
import ContactPage from '~/typings/pages/contact_page';

useHead({
  title: 'Contact'
});

const { findOne } = useStrapi();

const { data } = await useAsyncData(
  'contactpage',
  () => findOne<ContactPage>('contact-page', { populate: ['header', 'header.images'] }),
  {
    transform: flattenStrapiObject
  }
);
</script>
